import { render, staticRenderFns } from "./CaChipFiltros.vue?vue&type=template&id=dce44498"
import script from "./CaChipFiltros.vue?vue&type=script&lang=js"
export * from "./CaChipFiltros.vue?vue&type=script&lang=js"
import style0 from "./CaChipFiltros.vue?vue&type=style&index=0&id=dce44498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
